import React from "react";

export default function LandingPage() {
  return (
    <div className="main-page">
      <h1>Welcome to Shiba Sensei!</h1>
      <h2>Master Japanese Vocabulary: Your Gateway to Language Proficiency</h2>
      <p>
        Welcome to the ultimate destination for learning and practicing Japanese
        vocabulary - a dynamic platform designed to propel you towards language
        mastery through interactive typing exercises and cutting-edge spaced
        repetition technology!
      </p>

      <h2>Why Choose Our Japanese Vocabulary Platform?</h2>
      <ol>
        <li>
          <strong>Interactive Learning Experience:</strong> Say goodbye to
          tedious rote memorization! Our platform engages you with interactive
          typing exercises that make learning Japanese vocabulary fun and
          effective. The more you type, the more you learn!
        </li>
        <li>
          <strong>Spaced Repetition for Lasting Results:</strong> Unlock the
          power of spaced repetition - a scientifically proven technique that
          optimizes memory retention. Our intelligent algorithm adapts to your
          progress, ensuring you review words at the perfect intervals for
          long-term recall.
        </li>
        <li>
          <strong>Extensive Word Library:</strong> Dive into an ever-expanding
          database of Japanese words curated by language experts. From basic
          everyday terms to advanced expressions, we've got you covered across
          all proficiency levels.
        </li>
        <li>
          <strong>Learn at Your Own Pace:</strong> No rush, no pressure. Our
          platform lets you customize your learning journey. Study as
          intensively or casually as you prefer, and watch your vocabulary
          flourish over time.
        </li>
        <li>
          <strong>Real-world Context:</strong> Contextual learning is the key to
          language proficiency. Our vocabulary exercises are contextualized,
          enabling you to understand how words are used in various scenarios,
          conversations, and sentences.
        </li>
        <li>
          <strong>Mobile and Desktop Friendly:</strong> Learn anytime, anywhere!
          Access our platform seamlessly from your computer, tablet, or
          smartphone. Study on your daily commute, during lunch breaks, or from
          the comfort of your home.
        </li>
        <li>
          <strong>Track Your Progress:</strong> Stay motivated by tracking your
          progress and witnessing your improvement. Celebrate milestones as you
          master more and more Japanese words, building your confidence along
          the way.
        </li>
      </ol>

      <h2>What Our Users Say:</h2>
      <blockquote>
        <p>
          "I've tried several Japanese language platforms, but this one stands
          out! The spaced repetition really makes a difference, and the typing
          exercises are both challenging and enjoyable." - Rachel W.
        </p>
        <p>
          "Learning Japanese vocabulary has never been this engaging. The
          platform keeps me coming back for more, and my language skills have
          improved significantly in just a few weeks!" - Ethan K.
        </p>
      </blockquote>

      <h2>Join the Japanese Vocabulary Revolution:</h2>
      <p>
        Are you ready to embark on an exciting journey towards Japanese language
        proficiency? Empower yourself with a powerful tool that utilizes spaced
        repetition and interactive typing exercises to accelerate your
        vocabulary learning.
      </p>
      <p>
        <strong>
          Sign up now for our limited-time trial offer and take your first step
          towards Japanese fluency!
        </strong>{" "}
        Harness the potential of our platform to unlock new opportunities in
        cultural exchange, travel, business, and personal growth.
      </p>

      <p>
        Begin your transformation today and embrace the richness of the Japanese
        language! The world of Japanese vocabulary awaits you - start your
        adventure now!
      </p>
    </div>
  );
}
